export const apiConstants = {
  guide: '/directory',
};
